import { ConfirmButton, MainTitle } from 'ck-components';
import {
  CategoriesFormHandle,
  EditOrganizerCategoriesForm,
  EditOrganizerForm,
  OrganizerFormHandle,
} from '../../features/Organizer';
import { useRef, useState } from 'react';

export function Organizer() {
  const [selectedOrganizer, setSelectedOrganizer] = useState<
    { id: string; name: string } | undefined
  >();
  const categoriesFormRef = useRef<CategoriesFormHandle>(null);
  const organizerFormRef = useRef<OrganizerFormHandle>(null);
  const [isSaving, setIsSaving] = useState(false);

  return (
    <div className='flex w-full gap-10'>
      <div className='flex w-full flex-col gap-6'>
        <MainTitle label='Arrangörsida' />
        <EditOrganizerForm
          ref={organizerFormRef}
          onOrganizerChange={setSelectedOrganizer}
          beforeSubmit={() =>
            categoriesFormRef.current?.submit() ?? Promise.resolve(true)
          }
        />
        {selectedOrganizer && (
          <EditOrganizerCategoriesForm
            // Remounts on every organizer switch so the prefill ref/effect start fresh -
            // otherwise the multiselect can briefly (or, if the fetch is slow, not so
            // briefly) keep showing the previous organizer's categories while the new
            // one's GET is still in flight.
            key={selectedOrganizer.id}
            ref={categoriesFormRef}
            committeeId={selectedOrganizer.id}
          />
        )}
        <ConfirmButton
          type='button'
          className='w-52'
          label='Spara uppdateringar'
          isLoading={isSaving}
          disabled={isSaving || !selectedOrganizer}
          onClick={async () => {
            // Without this, clicking with nothing selected still flashes the loading
            // state: submit() only no-ops once inside EditOrganizerForm's own check.
            if (!selectedOrganizer) return;

            setIsSaving(true);
            try {
              await organizerFormRef.current?.submit();
            } finally {
              setIsSaving(false);
            }
          }}
        />
      </div>
    </div>
  );
}
